import React, { useMemo } from 'react';
import { useTheme, createTheme, ThemeProvider } from '@mui/material/styles';

/**
 * Wraps the Discover V2 subtree in a theme that inherits the app palette
 * (gold #FEBD1C primary / navy #111936 secondary) but swaps in the Inter
 * typeface and softens component styling for a more professional feel.
 * The v1 page is untouched because this only applies to children passed here.
 */
const FONT_STACK = "'Inter', 'Segoe UI', Roboto, system-ui, sans-serif";

const DiscoverThemeProvider = ({ children }) => {
  const base = useTheme();

  const theme = useMemo(
    () =>
      createTheme(base, {
        typography: {
          fontFamily: FONT_STACK,
          h1: { fontFamily: FONT_STACK },
          h2: { fontFamily: FONT_STACK },
          h3: { fontFamily: FONT_STACK, fontWeight: 700, letterSpacing: '-0.2px' },
          h4: { fontFamily: FONT_STACK, fontWeight: 700 },
          h5: { fontFamily: FONT_STACK, fontWeight: 600 },
          h6: { fontFamily: FONT_STACK, fontWeight: 600 },
          button: { fontFamily: FONT_STACK, fontWeight: 600 },
          body1: { fontFamily: FONT_STACK },
          body2: { fontFamily: FONT_STACK },
        },
        shape: { borderRadius: 10 },
        components: {
          MuiButton: {
            styleOverrides: {
              root: { textTransform: 'none', borderRadius: 9, fontWeight: 600 },
              containedPrimary: {
                color: '#111936',
                boxShadow: '0 4px 12px -5px rgba(254,189,28,0.8)',
              },
            },
          },
          MuiOutlinedInput: {
            styleOverrides: {
              root: {
                borderRadius: 10,
                backgroundColor: '#fff',
              },
            },
          },
          MuiChip: {
            styleOverrides: {
              root: { fontWeight: 600, borderRadius: 8 },
            },
          },
          MuiTableCell: {
            styleOverrides: {
              root: { borderColor: '#edeef3' },
            },
          },
          MuiPaginationItem: {
            styleOverrides: {
              root: { fontFamily: FONT_STACK, fontWeight: 600 },
            },
          },
        },
      }),
    [base],
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default DiscoverThemeProvider;
